<template>
  <div class="spot-trade-container">
    <!-- 现货交易筛选条件 -->
    <div class="filter-line" v-if="tabIndex == 0">
      <!-- 现货交易无特殊筛选条件 -->
      <div class="flex-start type-list">
        <div class="list" v-for="(item, i) in actionTypeList" :key="i" :class="item.value == actionType ? 'active' : ''" @click.stop="changeActionType(item)">
          {{item.text}}
        </div>
      </div>
    </div>

    <!-- 现货交易表单 -->
    <div class="form-box flex-center">
      <!-- 买入表单 -->
      <div class="left-form">
        <div class="trade-money ">
          <input type="number" :disabled="actionType == 1"  @change="changeMoney" v-model="tradeMoney" :placeholder="i18n.t('trade.label4')">
          <div class="flex-center icon">
            USDT
          </div>
        </div>

        <div class="trade-money " >
          <div>
            <input type="number" v-model="form.number" @change="changeCount" @input="changeCount" :placeholder="i18n.t('trade.label7')">
          </div>
          <div class="icon">{{bitInfo && bitInfo.ShortName ? bitInfo.ShortName : ''}}</div>
        </div>

        <div class="slide-box ">
          <div class="slide-inner flex-center" >
            <Slider v-model="tradeMoneyPercent" step="5" bar-height="4px" active-color="none" inactive-color="none" @change="changeSlide" @drag-start="dragStart" @drag-end="dragEnd">
               <template #button>
                <div class="custom-button"></div>
              </template>
            </Slider>
            <div class="slide-bg">
              <div class="slide-value flex-center" v-show="showPercent" :style="`left: ${tradeMoneyPercent}%;`">{{tradeMoneyPercent}}%</div>
              <div class="active-line" :style="`width: ${tradeMoneyPercent}%;`"></div>
              <div class="point" v-for="i in 6" :key="i" :class="[(i - 1) * 20 <= tradeMoneyPercent ? 'active' : '', `point${i}`]">
                <div class="value">{{(i - 1) * 20}}%</div>
              </div>
            </div>
          </div>
        </div>

        <div class="trade-money " v-show="actionType == 3">
          <div>
            <input type="number" inputmode="decimal"  v-model="form.stopPrice" :placeholder="i18n.t('trade.label5')">
          </div>
          <div class="icon">USDT</div>
        </div>

        <div class="flex-center-between user-amount">
          <div class="flex-center">
            <span class="label">{{i18n.t('trade.label3')}}：</span>
            <span v-if="!hideBalance">{{parseFloat(userMoney).toFixed(4) }} USDT</span>
            <span v-else>**** USDT</span>
            <Icon 
              :name="hideBalance ? 'eye-o' : 'eye'" 
              size="14" 
              color="#85898F" 
              @click="toggleBalance"
              class="balance-toggle ml-5"
            />
          </div>
          <div class="icon">
            <img :src="transferUrl2" alt="" @click="toTransfer">
          </div>
        </div>

        <div class="user-amount" v-show="actionType != 3">
          <div >
            <span class="label">{{$t('trade.label63')}}：</span>
            {{buyCount}}{{bitInfo.ShortName}}
          </div>
        </div>

        <div class="flex-center-between bottom-submit-btn" v-if="isLogin">
          <Button class="btn green" @click="submit(true)">{{i18n.t('trade.buy1')}}</Button>
        </div>
        <div class="flex-center-between bottom-submit-btn" v-if="!isLogin">
          <Button class="btn gray" @click.stop="toLogin">
            <span class="blue">{{i18n.t('login.title')}}</span>
            {{ $t('huo') }}	<span class="blue">{{i18n.t('register.btn4')}}</span>
          </Button>
        </div>
      </div>

      <!-- 卖出表单 -->
      <div class="right-form">
        <div class="trade-money ">
          <input type="number" :disabled="actionType == 1"  @change="changeMoney2" v-model="tradeMoney2" :placeholder="i18n.t('trade.label4')">
          <div class="flex-center icon">
            USDT
          </div>
        </div>

        <div class="trade-money " >
          <div>
            <input type="number" v-model="form.number2" @change="changeCount2" @input="changeCount2" :placeholder="i18n.t('trade.label7')">
          </div>
          <div class="icon">{{bitInfo && bitInfo.ShortName ? bitInfo.ShortName : ''}}</div>
        </div>

        <div class="slide-box ">
          <div class="slide-inner flex-center" >
            <Slider v-model="tradeMoneyPercent2" step="5" bar-height="4px" active-color="none" inactive-color="none" @change="changeSlide2" @drag-start="dragStart2" @drag-end="dragEnd2">
               <template #button>
                <div class="custom-button"></div>
              </template>
            </Slider>
            <div class="slide-bg">
              <div class="slide-value flex-center" v-show="showPercent2" :style="`left: ${tradeMoneyPercent2}%;`">{{tradeMoneyPercent2}}%</div>
              <div class="active-line" :style="`width: ${tradeMoneyPercent2}%;`"></div>
              <div class="point" v-for="i in 6" :key="i" :class="[(i - 1) * 20 <= tradeMoneyPercent2 ? 'active' : '', `point${i}`]">
                <div class="value">{{(i - 1) * 20}}%</div>
              </div>
            </div>
          </div>
        </div>

        <div class="trade-money " v-show="actionType == 3">
          <div>
            <input type="number" inputmode="decimal"  v-model="form.stopPrice2" :placeholder="i18n.t('trade.label5')">
          </div>
          <div class="icon">USDT</div>
        </div>

        <div class="flex-center-between user-amount" v-if="pageType == 1">
          <div class="flex-center">
            <span class="label">{{i18n.t('trade.label3')}}：</span>
            <span v-if="!hideBalance">{{userBitMoney}} {{bitInfo.ShortName}}</span>
            <span v-else>**** {{bitInfo.ShortName}}</span>
            <Icon 
              :name="hideBalance ? 'eye-o' : 'eye'" 
              size="14" 
              color="#85898F" 
              @click="toggleBalance"
              class="balance-toggle ml-5"
            />
          </div>
          <div class="icon">
            <img :src="transferUrl2" alt="" @click="toTransfer">
          </div>
        </div>

        <div class="user-amount" v-show="actionType != 3" v-if="pageType == 1">
          <div >
            <span class="label">{{$t('trade.label64')}}：</span>
            {{saleCount}}USDT
          </div>
        </div>

        <div class="flex-center-between user-amount" v-if="pageType == 3">
          <div class="flex-center">
            <span class="label">{{i18n.t('trade.label3')}}：</span>
            <span v-if="!hideBalance">{{parseFloat(userMoney).toFixed(4) }} USDT</span>
            <span v-else>**** USDT</span>
            <Icon 
              :name="hideBalance ? 'eye-o' : 'eye'" 
              size="14" 
              color="#85898F" 
              @click="toggleBalance"
              class="balance-toggle ml-5"
            />
          </div>
          <div class="icon">
            <img :src="transferUrl2" alt="" @click="toTransfer">
          </div>
        </div>

        <div class="user-amount" v-show="actionType != 3" v-if="pageType == 3">
          <div >
            <span class="label">{{$t('trade.label63')}}：</span>
            {{buyCount}}{{bitInfo.ShortName}}
          </div>
        </div>

        <div class="flex-center-between bottom-submit-btn" v-if="isLogin">
          <Button class="btn red" @click="submit(false)">{{i18n.t('trade.sell1')}}</Button>
        </div>
        <div class="flex-center-between bottom-submit-btn" v-if="!isLogin">
          <Button class="btn gray" @click.stop="toLogin">
            <span class="blue">{{i18n.t('login.title')}}</span>
            {{ $t('huo') }}
            <span class="blue">{{i18n.t('register.btn4')}}</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Slider, Icon } from 'vant';

export default {
  name: 'SpotTrade',
  components: {
    Button,
    Slider,
    Icon
  },
  props: {
    bitInfo: {
      type: Object,
      default: () => ({})
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    pageType: {
      type: Number,
      default: 1
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    userMoney: {
      type: [String, Number],
      default: '0.0000'
    },
    userBitMoney: {
      type: [String, Number], 
      default: '0.0000'
    },
    actionType: {
      type: Number,
      default: 1
    },
    transferUrl2: {
      type: String,
      default: ''
    },
    hideBalance: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        number: '',
        number2: '',
        totalMoney: '',
        stopPrice: '',
        stopPrice2: '',
      },
      tradeMoney: '',
      tradeMoney2: '',
      tradeMoneyPercent: 0,
      tradeMoneyPercent2: 0,
      showPercent: false,
      showPercent2: false,
      actionTypeList: [
        {
          value: 1,
          text: this.i18n.t('trade.type1')
        },
        {
          value: 2,
          text: this.i18n.t('trade.type2')
        },
        {
          value: 3,
          text: this.i18n.t('trade.type3')
        },
      ],
    }
  },
  computed: {
    buyCount() {
      if (this.bitInfo && this.bitInfo.count) {
        return (parseFloat(this.userMoney) / parseFloat(this.bitInfo.count)).toFixed(4)
      } else {
        return ''
      }
    },
    saleCount() {
      if (this.bitInfo.count) {
        return (parseFloat(this.userBitMoney) * parseFloat(this.bitInfo.count)).toFixed(4)
      } else {
        return ''
      }
    }
  },
  watch: {
    bitInfo: {
      handler(newVal) {
        if (newVal && newVal.count) {
          this.tradeMoney = newVal.count
          this.tradeMoney2 = newVal.count
        }
      },
      immediate: true
    }
  },
  methods: {
    changeActionType(data) {
      this.$emit('change-action-type', data)
    },
    dragStart() {
      this.showPercent = true
    },
    dragEnd() {
      this.showPercent = false
    },
    dragStart2() {
      this.showPercent2 = true
    },
    dragEnd2() {
      this.showPercent2 = false
    },
    changeCount() {
      if (this.tradeMoney) {
        this.form.totalMoney = parseFloat((this.tradeMoney * this.form.number).toFixed(6))
      }
    },
    changeCount2() {
      if (this.tradeMoney2) {
        this.form.totalMoney2 = parseFloat((this.tradeMoney2 * this.form.number2).toFixed(6))
      }
    },
    changeMoney() {
      if (this.form.number) {
        this.form.totalMoney = parseFloat((this.tradeMoney * this.form.number).toFixed(6))
      }
    },
    changeMoney2() {
      if (this.form.number2) {
        this.form.totalMoney2 = parseFloat((this.tradeMoney2 * this.form.number2).toFixed(6))
      }
    },
    changeSlide(val) {
      this.form.totalMoney = this.userMoney * (val / 100)
      if (this.tradeMoney) {
        this.form.number = parseFloat((this.form.totalMoney / this.tradeMoney).toFixed(6))
      }
    },
    changeSlide2(val) {
      this.form.number2 = this.userBitMoney * (val / 100)
      if (this.tradeMoney2) {
        this.form.totalMoney2 = parseFloat((this.tradeMoney2 * this.form.number2).toFixed(6))
      }
    },
    submit(isBuy) {
      this.$emit('submit-spot', {
        isBuy,
        actionType: this.actionType,
        tradeMoney: isBuy ? this.tradeMoney : this.tradeMoney2,
        form: this.form
      })
    },
    toTransfer() {
      this.$emit('to-transfer')
    },
    toLogin() {
      this.$emit('to-login')
    },
    toggleBalance() {
      this.$emit('toggle-balance')
    }
  }
}
</script>

<style scoped>
.filter-line {
  height: 40px !important;
}

.balance-toggle {
  cursor: pointer;
  margin-left: 5px;
  transition: opacity 0.2s;
}

.balance-toggle:hover {
  opacity: 0.7;
}

.ml-5 {
  margin-left: 5px;
}
</style> 